export const FEEDBACK_ON_DEMAND_TYPES = {
  ASKING: 'Asking',
  GIVING: 'Giving'
};

export const getFeedbackTypeColor = (type) => {
  switch (type) {
    case FEEDBACK_ON_DEMAND_TYPES.ASKING:
      return '#2E90FA'; // Blue color for asking feedback
    case FEEDBACK_ON_DEMAND_TYPES.GIVING:
      return '#16A34A'; // Green color for giving feedback
    default:
      return '#475569'; // Default slate color
  }
};

export const getFeedbackTypeText = (type) => {
  switch (type) {
    case FEEDBACK_ON_DEMAND_TYPES.ASKING:
      return 'Asking for Feedback';
    case FEEDBACK_ON_DEMAND_TYPES.GIVING:
      return 'Giving Feedback';
    default:
      return 'Unknown Type';
  }
};

export const getFeedbackTypeBorderColor = (type) => {
  switch (type) {
    case FEEDBACK_ON_DEMAND_TYPES.ASKING:
      return '#2E90FA'; // Blue border for asking feedback
    case FEEDBACK_ON_DEMAND_TYPES.GIVING:
      return '#16A34A'; // Green border for giving feedback
    default:
      return '#475569'; // Default slate border
  }
};

export const getFeedbackTypeTextColor = (type) => {
  switch (type) {
    case FEEDBACK_ON_DEMAND_TYPES.ASKING:
      return '#1D4ED8'; // Darker blue for text
    case FEEDBACK_ON_DEMAND_TYPES.GIVING:
      return '#15803D'; // Darker green for text
    default:
      return '#1E293B'; // Darker slate for text
  }
}; 